import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "./i18n/LanguageContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Services from "./pages/Services";
import ServiceDetail, { RiskAnalysis, Regulation, Industry, AIPage, ChiSiamo } from "./pages/ServiceDetail";
import Contact from "./pages/Contact";
import Insights from "./pages/Insights";
import Article from "./pages/Article";

const ScrollManager = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

const SmoothScroll = () => {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);
  return null;
};

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <SmoothScroll />
        <ScrollManager />
        <div className="min-h-screen bg-white font-sans text-ink antialiased">
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/servizi" element={<Services />} />
            <Route path="/servizi/:slug" element={<ServiceDetail />} />
            <Route path="/chi-siamo" element={<ChiSiamo />} />
            <Route path="/approfondimenti" element={<Insights />} />
            <Route path="/approfondimenti/:slug" element={<Article />} />
            <Route path="/risk-analysis" element={<RiskAnalysis />} />
            <Route path="/regolamento-ue" element={<Regulation />} />
            <Route path="/industria-4-5" element={<Industry />} />
            <Route path="/ai" element={<AIPage />} />
            <Route path="/contatti" element={<Contact />} />
            <Route path="*" element={<Home />} />
          </Routes>
          <Footer />
          <Toaster position="bottom-right" richColors />
        </div>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
